import React from 'react';
import {
  AS_BODY_KEY_VERIFICATION_STEP,
  AS_OTP_VERIFICATION_STEP,
} from '../../challengeConstants';
import AutoSyncBodyKeyVerification from '../autoSyncBodyKeyVerification/AutoSyncBodyKeyVerification';
import AutoSyncOtpVerification from '../autoSyncOtpVerification/AutoSyncOtpVerification';

export default function AutoSyncVerification({
  autoSyncStep,
  bodyKeyId,
  bodyKeyOtp,
  phoneNumber,
  errorDetail,
  otpTitle,
  otpTimer,
  otpErrorDetail,
  validationFailed,
  otpValidationFailed,
  onChangeHandler,
  amwayNumberError,
  onClose,
  onOtpClose,
  onVerify,
}) {
  const renderAutoSyncStep = (step) => {
    switch (step) {
      case AS_OTP_VERIFICATION_STEP:
        return (
          <AutoSyncOtpVerification
            phoneNumber={phoneNumber}
            bodyKeyOtp={bodyKeyOtp}
            otpValidationFailed={otpValidationFailed}
            otpTitle={otpTitle}
            otpTimer={otpTimer}
            otpErrorDetail={otpErrorDetail}
            onChangeHandler={onChangeHandler}
            onClose={onOtpClose}
            onVerify={onVerify}
          />
        );
      case AS_BODY_KEY_VERIFICATION_STEP:
        return (
          <AutoSyncBodyKeyVerification
            bodyKeyId={bodyKeyId}
            validationFailed={validationFailed}
            errorDetail={errorDetail}
            amwayNumberError={amwayNumberError}
            onChangeHandler={onChangeHandler}
            onClose={onClose}
            onVerify={onVerify}
          />
        );
    }
  };
  return <>{renderAutoSyncStep(autoSyncStep)}</>;
}
